import { Modal, ModalView } from "@inrange/theme-components";
import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";

// The two engines a human may CHOOSE. "manual" is server-derived (a site has custom objects
// or it does not) and is never a rebuild option.
export type AutoEngine = "auto-V1" | "auto-V2";

interface PvForceRebuildModalProps {
  defaultEngine?: AutoEngine;
  onConfirm: (engine: AutoEngine) => void;
  onClose: () => void;
}

// Small modal to force a fresh automated build, letting the user choose which
// roof-object detection engine runs. Defaults to V2 (SAM), the latest engine.
const PvForceRebuildModal: React.FC<PvForceRebuildModalProps> = ({
  defaultEngine = "auto-V2",
  onConfirm,
  onClose,
}) => {
  const [engine, setEngine] = useState<AutoEngine>(defaultEngine);

  return (
    <Modal>
      <ModalView
        id="pv-force-rebuild-modal"
        width="440px"
        title="Force rebuild"
        // Drop the title's default 32px top padding. ModalView appends `padding: <titlePadding>`
        // after its `padding-top: 32px`, so this overrides it — for this modal only, no change to
        // the shared component.
        titlePadding="0"
        description={
          <p>
            Re-run automated roof object detection for this site. Choose which
            detection engine to use.
          </p>
        }
      >
        <Form>
          <Form.Check
            type="radio"
            id="pv-engine-v2"
            name="pv-engine"
            label="V2 - AI object detection (recommended)"
            checked={engine === "auto-V2"}
            onChange={() => setEngine("auto-V2")}
            data-testid="pv-engine-v2"
          />
          <Form.Check
            type="radio"
            id="pv-engine-v1"
            name="pv-engine"
            label="V1 - Edge detection (legacy)"
            checked={engine === "auto-V1"}
            onChange={() => setEngine("auto-V1")}
            data-testid="pv-engine-v1"
          />
        </Form>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            marginTop: "20px",
          }}
        >
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="success"
            data-testid="pv-force-rebuild-confirm"
            onClick={() => {
              onConfirm(engine);
              onClose();
            }}
          >
            Rebuild
          </Button>
        </div>
      </ModalView>
    </Modal>
  );
};

export default PvForceRebuildModal;
